import { TransaccionesRecurrentesService as service } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const TransaccionesRecurrentesManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return service.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crear = (data) => {
    return service.crear(data).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const buscarPorId = (id) => {
    return service.buscarPorId(id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const actualizar = (id, data) => {
    return service.actualizar(id, data).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const cancelar = (id) => {
    return service.cancelar(id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const historicoEnvios = (id) => {
    return service.historicoEnvios(id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const ejecutarProceso = () => {
    return service.ejecutarProceso().then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const exportarExcel = (where) => {
    return service.exportarExcel(where).then((res) => {
      return res;
    });
  };

  return {
    listado,
    crear,
    buscarPorId,
    actualizar,
    cancelar,
    historicoEnvios,
    ejecutarProceso,
    exportarExcel
  };
})();
